import PropTypes from 'prop-types';

export default PropTypes.shape({
  city: PropTypes.string,
  state: PropTypes.string,
  street: PropTypes.string,
  street2: PropTypes.string,
  zip: PropTypes.string,
});
